import React from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Tooltip } from '@mui/material';

export default function RefreshButton({
  clickAction,
  sx = {},
  disabled = false,
  tooltipText = '',
  text = 'Reload data',
  variant = 'text',
  size = 'small',
  extraBtnProps = {},
}) {
  return (
    <Tooltip title={tooltipText} placement="top">
      <span>
        <Button
          disabled={disabled}
          variant={variant}
          size={size}
          sx={{ ...sx }}
          onClick={clickAction}
          startIcon={<RefreshIcon />}
          {...extraBtnProps}
        >
          {text}
        </Button>
      </span>
    </Tooltip>
  );
}
